// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__r4Q4u","description":"styles_description__Zyns0","wrapper__form":"styles_wrapper__form__dVXSJ","wrapper__video":"styles_wrapper__video__xiHB+"};